/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {Component} from 'react';
const $ = require('jquery');
class Accesspage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date()
        };
    }
    componentDidMount() {
        setTimeout(function () {
            if (($('.body-container').outerHeight(true) + $('header').outerHeight(true)) > $(window).height()) {
                $('footer').css({'position': 'relative', top: '57px'});
            } else {
                $('footer').css({'position': 'fixed', top: 'unset'});
            }
        }, 100);
    }

    componentWillUnmount() {
        $('footer').css({'position': 'fixed', top: 'unset'});
    }
    render() {
        return (
            <div className="custom-container">
                <div className="container-fluid">
                    <p className="text-center">You dont have access to this page or this is not a valid page.</p>
                    <p className="text-center">Please Contact Your Administrator</p>
                </div>
            </div>
        )
    }
}

export default Accesspage;